import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function RecruiterNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="sticky top-0 z-40 glass-panel border-b border-white/10" data-testid="recruiter-navbar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/recruiter/dashboard" className="flex items-center gap-2" data-testid="recruiter-navbar-logo">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-400 flex items-center justify-center">
            <ShieldCheck className="w-4 h-4 text-white" />
          </div>
          <span className="font-heading font-semibold text-white text-sm">Recruiter Portal</span>
        </Link>
        <div className="flex items-center gap-4">
          <span className="text-xs text-slate-400 hidden sm:inline" data-testid="recruiter-navbar-company">{user?.company_name}</span>
          <button onClick={handleLogout} data-testid="recruiter-navbar-logout-btn" className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </div>
    </nav>
  );
}
